import { defineStore } from 'pinia';
import { computed, reactive, ref } from 'vue';
import { defaultEnhancement } from './imageEnhancement';

export const useDentalImageDisplayStore = defineStore('dentalImageDisplay', () => {
  // Session display state only: opening a new sample starts with original gray.
  const settings = reactive(defaultEnhancement());
  const processing = reactive<Record<string, boolean>>({}); const error = ref('');
  const busy = computed(() => Object.values(processing).some(Boolean));
  const active = computed(() => settings.mode !== 'original' || settings.gamma !== 1 || settings.invert);
  function reset() { Object.assign(settings, defaultEnhancement()); error.value = ''; }
  return { settings, processing, error, busy, active, reset };
});
